(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ObjectTestSettingController', ObjectTestSettingController);

    ObjectTestSettingController.$inject = ['$scope', '$state', 'ObjectTestSetting', 'TabObjectTypes', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'TabFleets', 'TestSettingTag'];

    function ObjectTestSettingController ($scope, $state, ObjectTestSetting, TabObjectTypes, ParseLinks, AlertService, pagingParams, paginationConstants, TabFleets, TestSettingTag) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.filterType = pagingParams.objectTypes;
        vm.filterFleet = pagingParams.fleets;
        vm.filterTag = pagingParams.testSettingTag;
        vm.filterTagSelected = [];

        vm.charToSearch = pagingParams.search;

        if(vm.filterTag[0] !== -1) {
            vm.filterTag.forEach( tag => {vm.filterTagSelected.push({id: tag})});

        }
        vm.transition = transition;
        vm.applyTagsFilter = applyTagsFilter;
        vm.currentState = "object-test-setting";

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        //Aggiunta per impaginazione
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        var mappedObjectType = {};
        var allFleet = {id: -1, fleetName: "All"};
        var allObjectType = {id: -1, objectTypeName: "All"};

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadObjectType = function () {
            vm.filterType = {
                id: -1,
                objectTypeName: "All"
            };
            mapObjectType();
        }

        function mapObjectType() {
            TabObjectTypes.mapped().$promise.then(function (data) {
                mappedObjectType = JSON.parse(angular.toJson(data));
                mapObjectTypes();
                vm.objectTypes = mappedObjectType[vm.filterFleet.id];
            });

            function mapObjectTypes() {
                for (var fleet in mappedObjectType) {
                    if (mappedObjectType[fleet].length > 0) {
                        mappedObjectType[fleet].unshift(allObjectType);
                    }
                }
            }
        }


        TabFleets.query({size: 1000}, function (result) {
            vm.fleets = result;
            vm.fleets.unshift(allFleet);
        })

        TestSettingTag.byDomain({size: 1000}, function (result) {
            vm.testsTag = result;
            vm.testsTag.forEach((tag)=>{
                tag.label = tag.testTag;
            })
        })

        function applyTagsFilter() {
            console.log(vm.filterFleet.id, vm.filterTag.id, vm.filterTagSelected);

            vm.filterTag = vm.filterTagSelected.length > 0 ? vm.filterTagSelected.map(tag => tag.id) : [-1];
            transition(true);
        }

        vm.loadAll = function () {
            console.log(vm.filterFleet.id, vm.filterTag)
            ObjectTestSetting.searchTag({
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                objectTypeId: vm.filterType.id,
                fleetId: vm.filterFleet.id ,
                testTagId: vm.filterTag,
                query: vm.charToSearch
            }, onSuccess, onError);

            function onSuccess(data, headers,notify) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.objectTestSettings = data;
                vm.page = pagingParams.page;
                vm.transition(notify);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition(false);
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition(true);
        }

        function transition (notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort : sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                objectTypes: vm.filterType,
                fleets: vm.filterFleet,
                testSettingTag: vm.filterTag
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };
        mapObjectType();
        vm.loadAll();
        vm.tagListSettings = {
            checkboxes: true,
            smartButtonMaxItems: 10,
            buttonDefaultText: "Select tags",
            scrollable: true,
            enableSearch: true,
            clearSearchOnClose: true,
        };
    }
})();


